import { IFarmStatistics } from 'models/IFarm'
import axAPI from '../httpConfig'

export default class FarmApiService {
	static getFarmStatistic = async () => {
		return axAPI.get<IFarmStatistics>('farm/statistics')
	}
}
